import { awaitAuthReady, collections } from "@appally/lib/data/firebase";
import { doc, getDoc } from "firebase/firestore";

export const getUser = async (id: string) => {
  const docRef = doc(collections.users, id);
  const userDoc = await getDoc(docRef);
  if (!userDoc.exists()) {
    throw new Error("No user exists");
  }
  const data = userDoc.data();
  return data;
};

export const getCurrentUser = async () => {
  const user = await awaitAuthReady();
  const id = user?.uid;
  if (!id) return null;
  return getUser(id);
};

export const getCurrentUserAsOrgAdmin = async (orgId: string) => {
  if (!orgId) return null;
  const user = await getCurrentUser();
  if (!user?.organisation_id) return null;
  if (
    user.organisation_id?.toLowerCase() !== orgId.toLowerCase() ||
    !user.is_org_admin
  ) {
    return null;
  }
  return user;
};

export const getMyHelperOrInviter = async () => {
  const userAuth = await awaitAuthReady();
  const id = userAuth?.uid;
  if (!id) throw new Error("Not logged in");
  const assessment = await getDoc(doc(collections.assessments, id));
  if (!assessment.exists()) throw new Error("No user exists");

  // Get the helper
  const helperId = assessment.data().assigned_helper_user;
  if (!helperId) return undefined;
  const helper = await getUser(helperId);
  if (helper) return helper;

  // Get the inviter
  const user = await getCurrentUser();
  const inviterId = user?.team_invite;
  if (inviterId) {
    const inviter = await getDoc(doc(collections.users, helperId));
    if (inviter.exists()) {
      const data = inviter.data();
      return data;
    }
  }
};

export const isReferralCodeValid = async (
  referral_code_id: string | null | undefined,
) => {
  if (!referral_code_id) {
    // Error if no referral code is provided
    throw new Error("No referral code provided");
  }

  // Validate the referral code
  const referralCodeRef = doc(collections.referral_codes, referral_code_id);
  const referralCode = await getDoc(referralCodeRef);
  if (!referralCode.exists()) {
    throw new Error("Invalid referral code");
  }

  const data = referralCode.data();
  if (data.current_claimed >= data.max_claimed) {
    throw new Error("Referral code has reached its limit");
  }

  return true;
};
